import {faCircleExclamation} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'antd';

import {useDomainConfig} from '../../../../../../../../../provider/domain-config/domain-config-hook';
import {Locale} from '../../../../../../../../../provider/locale/localization';
import {classNames} from '../../../../../../../../../util/css';
import type {StoreAccountDetachedLinkAppType} from '../add-appstore-account-helper';

import * as styles from './appstore-bind-confirm-modal.scss';

type PropsType = {
    detachedApps: Array<StoreAccountDetachedLinkAppType>;
    isSaveLoading: boolean;
    onCancel: () => void;
    onSave: () => Promise<void>;
    open: boolean;
};

export function AppstoreBindConfirmModal(props: PropsType): JSX.Element {
    const {detachedApps, isSaveLoading, onCancel, onSave, open} = props;
    const {companyName} = useDomainConfig();

    const appNamesText = detachedApps.map((app) => app.appName).join(', ');

    function handleCancel(): void {
        if (isSaveLoading) {
            return;
        }

        onCancel();
    }

    return (
        <Modal
            closable={!isSaveLoading}
            destroyOnClose
            footer={[
                <Button disabled={isSaveLoading} key="cancel" onClick={handleCancel}>
                    <Locale stringKey="POPUP__BUTTON__CANCEL" />
                </Button>,
                <Button
                    key="save"
                    loading={isSaveLoading}
                    onClick={async () => {
                        await onSave();
                    }}
                    type="primary"
                >
                    <Locale stringKey="BUTTON__SAVE" />
                </Button>,
            ]}
            keyboard={!isSaveLoading}
            maskClosable={!isSaveLoading}
            onCancel={handleCancel}
            open={open}
            title={
                <div className={styles.AppstoreBindConfirmModal_titleRow}>
                    <FontAwesomeIcon
                        className={classNames('anticon', styles.AppstoreBindConfirmModal_icon)}
                        icon={faCircleExclamation}
                    />
                    <span className={styles.AppstoreBindConfirmModal_titleText}>
                        <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__BIND_CONFIRM__TITLE" />
                    </span>
                </div>
            }
            width={400}
        >
            <p className={styles.AppstoreBindConfirmModal_body}>
                <Locale
                    stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__BIND_CONFIRM__BODY"
                    valueMap={{
                        appNames: (
                            <span className={styles.AppstoreBindConfirmModal_appNames} key="appNames">
                                {appNamesText}
                            </span>
                        ),
                        companyName: <span key="companyName">{companyName}</span>,
                    }}
                />
            </p>
        </Modal>
    );
}
